/**
 * Sync API Service
 *
 * Grundlage für Offline-Synchronisation: liefert alle seit einem Zeitpunkt
 * geänderten Daten des Users in einer Antwort.
 *
 * Endpoints:
 * GET /sync/changes?since=... - Änderungen seit Zeitpunkt laden
 */

import { get } from '../client';

const LAST_SYNC_KEY = 'lastSyncTime';

/**
 * Änderungen seit einem Zeitpunkt laden
 * @param {string|null} since - ISO-8601 UTC Timestamp (optional, ohne = alle Daten)
 * @returns {Promise<{success: boolean, data?: SyncChanges, error?: object}>}
 */
export const getChanges = async (since = null) => {
  const params = {};
  if (since) params.since = since;
  return get('/sync/changes', params);
};

/**
 * Letzten lokal gespeicherten Sync-Zeitpunkt lesen
 * @returns {string|null}
 */
export const getLastSyncTime = () => {
  return localStorage.getItem(LAST_SYNC_KEY);
};

/**
 * Sync-Zeitpunkt lokal speichern (aus data.server_time der Sync-Response)
 * @param {string} serverTime - ISO-8601 UTC Timestamp
 */
export const setLastSyncTime = (serverTime) => {
  if (serverTime) localStorage.setItem(LAST_SYNC_KEY, serverTime);
};

/**
 * Führt einen Sync-Zyklus aus: lädt Änderungen seit dem letzten lokal
 * gespeicherten Zeitpunkt und aktualisiert diesen anschließend.
 * @returns {Promise<{success: boolean, data?: SyncChanges, error?: object}>}
 */
export const syncChanges = async () => {
  const since = getLastSyncTime();
  const result = await getChanges(since);
  if (result.success && result.data?.server_time) {
    setLastSyncTime(result.data.server_time);
  }
  return result;
};

// ============================================================================
// TYPES (JSDoc)
// ============================================================================

/**
 * @typedef {object} SyncChanges
 * @property {object[]} library
 * @property {object[]} wishlist
 * @property {object[]} notifications
 * @property {object=} settings
 * @property {object=} privacy
 * @property {string} server_time
 */
